import { render, staticRenderFns } from "./SummaryItemActionsNew.vue?vue&type=template&id=2027356b&"
import script from "./SummaryItemActionsNew.vue?vue&type=script&lang=js&"
export * from "./SummaryItemActionsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports